import { useLang } from "@/context/LanguageContext";

// Sélecteur global FR/EN (en-tête). Mémorisé sur le compte.
export default function LanguageToggle({ className = "" }) {
  const { lang, setLang } = useLang();
  return (
    <div data-testid="lang-toggle"
      className={"inline-flex rounded-full overflow-hidden border " + className}
      style={{ borderColor: "var(--surface-border, rgba(255,255,255,.15))" }}>
      {["fr", "en"].map((l) => (
        <button key={l} data-testid={`lang-${l}`} onClick={() => setLang(l)}
          aria-pressed={lang === l}
          className={"px-3 py-2 min-w-[40px] text-xs font-semibold transition-colors " +
            (lang === l ? "gold-gradient text-black" : "text-white/60 hover:text-white")}>
          {l.toUpperCase()}
        </button>
      ))}
    </div>
  );
}
